import { Dialog } from "@headlessui/react";
import { useState, useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";
import { getConsentPDFContent } from "service/userservice/getConsentPDFContent";
import { useTranslation } from "react-i18next";

export default function PaymentDialog({
  showPaymentDialog,
  setShowPaymentDialog,
  action,
  data,
}) {
  const { t } = useTranslation();
  const componentRef = useRef();

  const [consentContent, setConsentContent] = useState();
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    PaymentPDFContent();
  }, [data]);

  // This code is to capture user input that is in html
  const inputMessage = (event) => {
    if (event.origin !== window.location.origin) return;

    const { type, payload } = event.data;
    if (type === "inputValue") {
      setInputValue(payload);
    }
  };
  window.addEventListener("message", inputMessage);

  const PaymentPDFContent = async () => {
    const mapObj = {
      // REPLACE_POLICY_ID: "Test id",
      // REPLACE_POLICY_OWNER_NAME: "test1",
      // REPLACE_VIEW_BALANCE_PAID: "show",
      // REPLACE_POLICY_BALANCE_PAID: "test2",
      // REPLACE_VIEW_AMOUNT: "show",
      // REPLACE_POLICY_AMOUNT: "test3",
      // REPLACE_POLICY_DATE: "test4",
      // REPLACE_POLICY_CARD_DETAILS: "test5",
      // REPLACE_VIEW_FREQUENCY: "show",
      // REPLACE_POLICY_FREQUENCY: "test6",
      ...data,
      REPLACE_INPUT_VALUE: inputValue,
    };
    // TODO: form name will be dynamic in future pr
    await getConsentPDFContent("EL_Autopay_Consent.html", "inline")
      .then((consentPDFContent) => {
        const updateForm = consentPDFContent.replace(
          /REPLACE_POLICY_ID|REPLACE_POLICY_OWNER_NAME|REPLACE_VIEW_BALANCE_PAID|REPLACE_POLICY_BALANCE_PAID|REPLACE_VIEW_AMOUNT|REPLACE_POLICY_AMOUNT|REPLACE_POLICY_DATE|REPLACE_POLICY_CARD_DETAILS|REPLACE_VIEW_FREQUENCY|REPLACE_POLICY_FREQUENCY|REPLACE_INPUT_VALUE/gi,
          (matched) => {
            return mapObj[matched];
          }
        );
        setConsentContent(updateForm);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Print form
  const handlePrint = async () => {
    await PaymentPDFContent(); // Update form again before printing
    updateReactoPrint();
  };
  const updateReactoPrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <Dialog
      open={showPaymentDialog}
      onClose={() => null}
      className="ui-dialogs"
    >
      <DialogBackdrop />
      {/* Full-screen container to center the panel */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel
          role="dialog"
          aria-modal="true"
          className="ui-default-dialog"
        >
          <Dialog.Title className="sr-only">
            {t("CustomerEditManageAutoPay-payment-dialog-title")}
          </Dialog.Title>
          <div className="ui-grid-manage-notification" key="keyFieldset">
            <div id="divpdfcontent" className="h-[600px] overflow-scroll">
              <div className="flex justify-between">
                <span className="flex algin-center font-bold ml-2.5">
                  {t(
                    "CustomerEditManageAutoPay-payment-dialog-payment-authorization"
                  )}
                </span>
                <div className="">
                  <span
                    className="pr-8 text-ui-blue underline mr-6"
                    onClick={handlePrint}
                  >
                    {t("CustomerEditManageAutoPay-payment-dialog-print-form")}
                  </span>
                  <button
                    className="ui-default-dialog-close mt-[-2px]"
                    aria-label="close manage notification preferences window"
                    onClick={() => {
                      setShowPaymentDialog(false);
                    }}
                  >
                    <svg
                      className="ui-icon h-3.5 w-3.5"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-close"></use>
                    </svg>
                  </button>
                </div>
              </div>
              <div>
                <iframe
                  className="h-[2200px] w-[600px]"
                  title="test"
                  srcDoc={consentContent}
                  ref={componentRef}
                  height={"100%"}
                />
              </div>
            </div>
          </div>
          {/* <!-- Buttons --> */}
          <div className="block text-right mt-6">
            <span className="pr-8 text-ui-blue underline" onClick={handlePrint}>
              {t("CustomerEditManageAutoPay-payment-dialog-print-form")}
            </span>
            <button
              className="ui-btn-primary ui-btn-min-w mt-4"
              id="ID_Agree"
              disabled={!inputValue}
              onClick={() => {
                action(inputValue);
              }}
            >
              {t("CustomerEditManageAutoPay-payment-dialog-save-changes")}
              <span className="sr-only">Agree and close consent</span>
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
